import { call, put } from 'redux-saga/effects';
import {
  uploadPatientFilesRequest,
  uploadPatientFilesSuccess,
  uploadPatientFilesFailure,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* uploadPatientFilesByPatient(action) {
  yield put(uploadPatientFilesRequest());
  const patientId = action.payload.param.patientId;
  const departmentId = action.payload.param.departmentId;
  const files = action.payload.param.files;

  const data = new FormData();
  files.forEach((file) => {
    data.append(`file`, file, file.name);
  });

  try {
    const result = yield call(
      Api.upload,
      `${urls.aspariaBackend}api/v1/patient/fileUpload/${departmentId ? departmentId + '/' : ''}${patientId}`,
      data,
      action.progressCallback
    );
    if (result) {
      action.callback(result);
      yield put(uploadPatientFilesSuccess());
    } else {
      yield put(uploadPatientFilesFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(uploadPatientFilesFailure(e));
  }
}

export const uploadPatientFilesSagaAction = (param, cb, progressCb) => ({
  type: SagaTypes.UPLOAD_PATIENT_FILES,
  payload: { param },
  callback: cb,
  progressCallback: progressCb,
});
